export const SET_LOCALE = 'SET_LOCALE';
export const SET_THEME = 'SET_THEME';
export const SET_AUTH_STATUS = 'SET_AUTH_STATUS';
export const SET_AUTH_STATE = 'SET_AUTH_STATE';
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';
export const SET_AUTH_CHECK_STATUS = 'SET_AUTH_CHECK_STATUS';
export const SET_LOGIN_PAGE_ENABLED = 'SET_LOGIN_PAGE_ENABLED';
